import React from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import FeedbackScreen from '../components/FeedbackScreen';
import { useApp } from '../context/AppContext';

const FeedbackPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useApp();

  // Redirecionar para a página inicial se não houver usuário logado
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  const handleBack = () => {
    navigate('/menu'); // Navega diretamente para o Menu Principal
  };

  const handleComplete = () => {
    navigate('/');
  };

  return (
    <Box height="100vh" width="100%" bg="black">
      {currentUser && (
        <FeedbackScreen 
          clientName={currentUser.name} 
          onBack={handleBack} 
          onComplete={handleComplete} 
        />
      )}
    </Box>
  );
};

export default FeedbackPage;
